import React from 'react';
import AddPointOnTheMapMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/map/addPointOnTheMap/AddPointOnTheMapMutateSingleVoyage";
import PointsOnTheMapMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/map/pointsOnTheMap/PointsOnTheMapMutateSingleVoyage";
import {
    useViewContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/viewContext/hooks/useViewContextMutateSingleVoyage";
import ChangeCorrectionPointsWithSelectPointMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/changeCorrectionPoints/ChangeCorrectionPointsWithSelectPointMutateSingleVoyage";
import {
    useRootContextMutateSingleVoyage
} from "@containers/singleVoyage/mutateVoyage/context/rootContext/hooks/useRootContextMutateSingleVoyage";
import ToChangeCorrectionPointsModeBtnMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/correctionPoints/actionBarChangeCorrectionPoints/ToCorrectionPointsModeBtnMutateSingleVoyage";
import TargetPointRadiusMarkerMutateSingleVoyage
    from "@containers/singleVoyage/mutateVoyage/points/map/targetPointRadiusMarker/TargetPointRadiusMarkerMutateSingleVoyage";

import CloseStopsMapSingleVoyage
    from "@containers/singleVoyage/containers/closeStops/CloseStopsMapSingleVoyage";
const PointsMapMutateSingleVoyage = () => {

    const {mode} = useViewContextMutateSingleVoyage()
    const {points} = useRootContextMutateSingleVoyage()

    return (
        <>
            {mode === 'points' && <>
                <TargetPointRadiusMarkerMutateSingleVoyage/>
                <CloseStopsMapSingleVoyage/>
                <AddPointOnTheMapMutateSingleVoyage/>
                <PointsOnTheMapMutateSingleVoyage/>

                <ToChangeCorrectionPointsModeBtnMutateSingleVoyage/>
            </>}


            {mode === 'changeCorrectionPoints' && points?.length >= 2 &&
                <ChangeCorrectionPointsWithSelectPointMutateSingleVoyage/>}
        </>
    );
};

export default PointsMapMutateSingleVoyage;